module.exports = __webpack_public_path__ + "static/media/Danilo Mourelle - CV.72ccbe79.pdf";